import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehicleComponent from './vehicle.component';
import VehicleList from './vehicleList/vehicleList';
import VehicleEdit from './vehicleEdit/vehicleEdit';
import VehiclePublish from './vehiclePublish/vehiclePublish';
import VehicleService from './vehicle.service';
import VehicleAppraisal from './vehicleAppraisal/vehicleAppraisal';
import DeliveredVehicles from './deliveredVehicles/deliveredVehicles';
import SimiLookup from './simiLookup/simiLookup';
import VehicleAddSkupenet from './vehicleAddSkupenet/vehicleAddSkupenet';

let vehicleModule = angular.module('vehicle', [
  uiRouter,
  VehicleList,
  VehicleEdit,
  VehiclePublish,
  VehicleAppraisal,
  DeliveredVehicles,
  SimiLookup,
  VehicleAddSkupenet
])

.component('vehicle', vehicleComponent)

.service('vehicleService', VehicleService)

.name;

export default vehicleModule;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicle.js